import React, { useState, useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import { useHistory } from "react-router-dom";
import axios from "axios";

import AlbaraZammadForm from "../../forms/AlbaraZammadForm";

import logoAlbarans from "../../assets/images/logo-albarans.png";
import logoOdoo from "../../assets/images/logo-zammad.png"; // ⚠ si no tens aquesta imatge, canvia per logoZammad o crea-la
import { BiLink } from "react-icons/bi";
import { FiLoader } from "react-icons/fi";

const NewAlbaraOdoo = ({ params }) => {
	const { addToast } = useToasts();
	const history = useHistory();

	const saleOrderId = params.sale_order_id;

	// Estat de l'albarà (mateixa estructura que NewAlbaraZammad per reutilitzar el formulari)
	const [albara, setAlbara] = useState({
		empresa: null,
		operador: JSON.parse(localStorage.getItem("userLogged")).id,
		minuts_facturats: 0,
		incidencia: "",
		tipus_manteniment: "1",
		idServei: null,
		idTicket: `ODOO-${saleOrderId}`,        // Odoo no té ticket Zammad
		idTecnic: null,
		idSubServei: null,
		minutsDedicats: "",
		horesDedicades: "",
		// Camp extra per saber d'on ve l'albarà:
		idSaleOrder: saleOrderId,
		saleOrderName: "",
	});

	const [getCurrentMinutes, setCurrentMinutes] = useState(0);

	// Llistes per al formulari
	const [getEmpreses, setEmpreses] = useState(null);
	const [getServeis, setServeis] = useState(null);
	const [getSubServeis, setSubServeis] = useState(null);
	const [getTecnics, setTecnics] = useState(null);
	const [getMinutes, setMinutes] = useState(null);

	// Info de l'usuari per mostrar a la capçalera
	const [getOdooUserName, setOdooUserName] = useState("");

	const [getLoadError, setLoadError] = useState(null);

	useEffect(() => {
		async function fetchData() {
			let isUnauthorizedError = false;

			// === 1. Llegir dades del sale.order d'Odoo ===
			try {
				const resOdoo = await axios.get(
					`${process.env.REACT_APP_API_URL}api/odoo/sale-order/${saleOrderId}`,
					{
						auth: {
							username: process.env.REACT_APP_API_USER,
							password: process.env.REACT_APP_API_PWD,
						},
						headers: {
							token: JSON.parse(localStorage.getItem("userLogged")).token,
							idOperador: JSON.parse(localStorage.getItem("userLogged")).id,
						},
					}
				);

				const odooData = resOdoo?.data?.data;
				if (!resOdoo?.data?.success || !odooData) {
					throw new Error(resOdoo?.data?.error || "Resposta invàlida del endpoint Odoo");
				}

				setOdooUserName(odooData.tecnic_name || "");

				setAlbara((prevState) => ({
					...prevState,
					empresa: odooData.empresa ? String(odooData.empresa) : "0",
					idTecnic: odooData.operador ? Number(odooData.operador) : 0,
					incidencia: odooData.incidencia || "",
					saleOrderName: odooData.sale_order_name || "",
					// Per defecte deixem servei/subservei a buit: l'usuari els tria
					idServei: "0",
					idSubServei: "0",
				}));
			} catch (error) {
				console.error("⚠ Error API Odoo sale-order: ", error);
				if (error?.response?.status === 401) {
					isUnauthorizedError = true;
				}
				setLoadError(
					error?.response?.data?.error ||
						error?.message ||
						"No s'han pogut carregar les dades del pedido d'Odoo."
				);
			}

			// === 2. Llistes de la API Gestinet (igual que NewAlbaraZammad) ===

			// Empreses
			try {
				const apiCallGet = await axios.get(
					process.env.REACT_APP_API_URL + "api/empreses/",
					{
						auth: {
							username: process.env.REACT_APP_API_USER,
							password: process.env.REACT_APP_API_PWD,
						},
						headers: {
							token: JSON.parse(localStorage.getItem("userLogged")).token,
							idOperador: JSON.parse(localStorage.getItem("userLogged")).id,
						},
					}
				);
				setEmpreses(apiCallGet?.data);
			} catch (error) {
				console.error("⚠ Error API empreses: ", error);
				if (error?.response?.status === 401) isUnauthorizedError = true;
				setEmpreses([]);
			}

			// Serveis
			try {
				const apiCallGet = await axios.get(
					process.env.REACT_APP_API_URL + "api/serveis/",
					{
						auth: {
							username: process.env.REACT_APP_API_USER,
							password: process.env.REACT_APP_API_PWD,
						},
						headers: {
							token: JSON.parse(localStorage.getItem("userLogged")).token,
							idOperador: JSON.parse(localStorage.getItem("userLogged")).id,
						},
					}
				);
				setServeis(apiCallGet?.data);
			} catch (error) {
				console.error("⚠ Error API serveis: ", error);
				if (error?.response?.status === 401) isUnauthorizedError = true;
				setServeis([]);
			}

			// Subserveis
			try {
				const apiCallGet = await axios.get(
					`${process.env.REACT_APP_API_URL}api/serveis/subserveis/`,
					{
						auth: {
							username: process.env.REACT_APP_API_USER,
							password: process.env.REACT_APP_API_PWD,
						},
						headers: {
							token: JSON.parse(localStorage.getItem("userLogged")).token,
							idOperador: JSON.parse(localStorage.getItem("userLogged")).id,
						},
					}
				);
				setSubServeis(apiCallGet?.data);
			} catch (error) {
				console.error("⚠ Error API subserveis: ", error);
				if (error?.response?.status === 401) isUnauthorizedError = true;
				setSubServeis([]);
			}

			// Tècnics
			try {
				const apiCallGet = await axios.get(
					process.env.REACT_APP_API_URL + "api/tecnics/",
					{
						auth: {
							username: process.env.REACT_APP_API_USER,
							password: process.env.REACT_APP_API_PWD,
						},
						headers: {
							token: JSON.parse(localStorage.getItem("userLogged")).token,
							idOperador: JSON.parse(localStorage.getItem("userLogged")).id,
						},
					}
				);
				setTecnics(apiCallGet?.data);
			} catch (error) {
				console.error("⚠ Error API tecnics: ", error);
				if (error?.response?.status === 401) isUnauthorizedError = true;
				setTecnics([]);
			}

			// Llista de minuts (mateix bucle que NewAlbaraZammad)
			const numMinuts = 49;
			const minutsArray = [];
			for (let i = 0; i < numMinuts; i++) {
				const minuts = 30 * i;
				const hores = minuts / 60;
				minutsArray.push({
					value: minuts,
					label: `${minuts} min (${hores} h)`,
				});
			}
			setMinutes(minutsArray);

			if (isUnauthorizedError) {
				localStorage.removeItem("userLogged");
				window.location.reload();
			}
		}

		fetchData();
		// eslint-disable-next-line
	}, []);

	// CRUD: POST -- mateix endpoint que NewAlbaraZammad (sense actualització de Zammad)
	const handleSubmit = (e) => {
		document.getElementById("btnCrearAlbara").disabled = true;
		e.preventDefault();

		if (
			albara.idServei === "0" ||
			albara.idSubServei === "0" ||
			albara.empresa === "0" ||
			albara.idServei === "" ||
			albara.idSubServei === "" ||
			albara.empresa === "" ||
			albara.minuts_facturats === 0
		) {
			document.getElementById("btnCrearAlbara").disabled = false;
			return addToast("Falten dades: empresa, servei, subservei o minuts facturats.", {
				appearance: "error",
			});
		}

		axios
			.post(
				process.env.REACT_APP_API_URL + "api/albara/zammad/create/albara",
				{ albara },
				{
					auth: {
						username: process.env.REACT_APP_API_USER,
						password: process.env.REACT_APP_API_PWD,
					},
					headers: {
						token: JSON.parse(localStorage.getItem("userLogged")).token,
						idOperador: JSON.parse(localStorage.getItem("userLogged")).id,
					},
				}
			)
			.then((res) => {
				addToast("Albarà creat!", { appearance: "success", autoDismiss: true });
				// Redirigim a la pàgina d'imputar material (reutilitzem ImputarMaterialZammad)
				// Com no tenim ticket Zammad, posem el sale_order_id com a referència visual:
				history.push(
					`/odoo/${saleOrderId}/albara-odoo/${res?.data?.numAlbara}/imputar-material/`
				);
			})
			.catch((error) => {
				console.log(error);
				addToast("S'ha produït un error en crear l'albarà.", {
					appearance: "error",
				});
				document.getElementById("btnCrearAlbara").disabled = false;
			});
	};

	// === RENDER ===

	if (getLoadError) {
		return (
			<div className="fixed top-0 left-0 flex flex-col items-center justify-center w-full h-full p-0 m-0 space-y-8">
				<h2 className="text-2xl font-bold text-red-700">Error</h2>
				<p className="text-lg">{getLoadError}</p>
				<a
					href="/tickets"
					className="px-4 py-2 text-white bg-blue-700 rounded hover:bg-blue-800"
				>
					Tornar
				</a>
			</div>
		);
	}

	const allLoaded =
		albara.empresa !== null &&
		albara.idTecnic !== null &&
		albara.idServei !== null &&
		albara.idSubServei !== null &&
		getEmpreses !== null &&
		getServeis !== null &&
		getSubServeis !== null &&
		getTecnics !== null &&
		getMinutes !== null;

	if (!allLoaded) {
		return (
			<div className="fixed top-0 left-0 flex flex-col items-center justify-center w-full h-full p-0 m-0 space-y-16">
				<span
					className="flex flex-row items-center justify-center"
					style={{ color: "#34588d" }}
				>
					<span className="rounded-full w-28 h-28 bg-cyan-50 ring-2 ring-cyan-100">
						<img src={logoAlbarans} alt="logo" className="w-28" loading="lazy" />
					</span>
					<BiLink size="52" className="mx-4" />
					<span className="rounded-full w-28 h-28 bg-orange-50 ring-2 ring-orange-100 flex items-center justify-center text-2xl font-bold text-orange-700">
						Odoo
					</span>
				</span>
				<span
					className="flex items-center justify-center animate-bounce"
					style={{ color: "#34588d" }}
				>
					<FiLoader size="80" className="animate-spin text-cyan-900" />
				</span>
			</div>
		);
	}

	return (
		<>
			<div
				style={{
					borderBottom: "1px solid #dee2e6",
					marginTop: "1.4rem",
					marginBottom: "1rem",
					overflow: "hidden",
					width: "100%",
				}}
			>
				<h1
					style={{
						color: "#34588d",
						fontSize: "1.75rem",
						float: "left",
						fontWeight: "600",
						marginBottom: "15px",
					}}
				>
					Pedido Odoo
					{" » "}
					<span className="text-orange-700">
						{albara.saleOrderName || `#${saleOrderId}`}
					</span>
					{" » Crear albarà"}
				</h1>
			</div>

			<AlbaraZammadForm
				albara={albara}
				setAlbara={setAlbara}
				handleSubmit={handleSubmit}
				zammadTicketId={null}
				zammadUserId={albara.idTecnic}
				zammadUserName={getOdooUserName}
				zammadOrganizationid={albara.empresa}
				zammadTicketTimeUnit={0}
				zammadUserTimeUnit={0}
				gestinetEmpreses={getEmpreses}
				gestinetServeis={getServeis}
				gestinetSubServeis={getSubServeis}
				gestinetTecnics={getTecnics}
				gestinetMinutes={getMinutes}
				getCurrentMinutes={getCurrentMinutes}
				setCurrentMinutes={setCurrentMinutes}
			/>
		</>
	);
};

export default NewAlbaraOdoo;